module.exports = __webpack_public_path__ + "media/images/products/check-c72085007af13db7d6ecfb3168e5a505.svg";